import {Platform, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  maintenanceLogoStyle: {
    width: '100%',
    height: '25%',
  },
  logoImageStyle: {
    width: '75%',
    height: '75%',
  },
  bannerStyle: {
    width: '100%',
    height: 120,
  },
  // added for logo
  logoContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },

  optaviaText: {
    flexDirection: 'row',
    paddingTop: 6,
    paddingBottom: Platform.select({android: 4, ios: 0}),
  },

  optaviaBold: {
    fontSize: 34,
    lineHeight: 38,
    fontWeight: '500',
    letterSpacing: 1,
    color: '#000000',
  },

  optaviaRegular: {
    fontSize: 34,
    lineHeight: 38,
    fontWeight: '300',
    letterSpacing: 1,
    color: '#000000',
  },

  logoIcon: {
    width: 110,
    height: 110,
    marginBottom: 2,
  },

  coachText: {
    paddingTop: Platform.select({android: 1, ios: 7}),
    fontSize: 28,
    fontWeight: '200',
    letterSpacing: 3,
    color: '#000000',
    marginTop: Platform.select({android: 0, ios: 4}),
  },
  registered: {
    fontSize: 8,
    fontWeight: '400',
    marginLeft: 2,
    lineHeight: 22,
    textAlignVertical: 'top',
  },
});
